import styled from 'styled-components';
import { SeasonalRuleColor } from 'models/seasonality/SeasonalRule';
import { SEASONAL_RULE_COLOR_HEX } from 'models/seasonality/SeasonalRuleColors';

export const ActionsCellStyled = styled.div`
  align-items: center;
  display: flex;
  gap: 6px;

  button {
    padding: 6px 6px;
  }
`;

export const ColorCellStyled = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;
`;

export const ColorDot = styled.span<{ $color: SeasonalRuleColor }>`
  background-color: ${({ $color }) => SEASONAL_RULE_COLOR_HEX[$color]};
  border-radius: 50%;
  display: inline-block;
  height: 10px;
  opacity: 0.6;
  width: 10px;
`;

export const DetailsCellText = styled.span`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const DetailsCellTooltipContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  text-align: left;
`;

export const DetailsCellTooltipRow = styled.div`
  line-height: 1.35;
`;
